export const argoCDTemplatePatchSchema = {
  type: 'string',
  pattern: '^templatePatch: \\|\\n(\\s\\s.*\\n?)*$',
  title: 'Template Patch',
  description:
    'Must start with "templatePatch: |" (no leading/trailing spaces), followed by lines indented with at least 2 spaces.',
};
